import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getSources, saveSourcesBatch } from '../../api/sources';
import type { Source } from '../../types/Source';
import { t } from '../../i18n/t';

const sourcesColumnDefs: ColDef<Source>[] = [
  {
    field: 'sourceId',
    headerName: t('sources.columns.sourceId'),
    width: 140,
    // Natural PK: editable on Add only; existing rows must keep their code.
    editable: (params: EditableCallbackParams<Source>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'sourceName',
    headerName: t('sources.columns.sourceName'),
    flex: 1,
    editable: true,
  },
];

const newSourceDefaults = (): Partial<Source> => ({
  sourceId: 0,
  sourceName: '',
});

export function SourcesPage() {
  return (
    <LopCrudPage<Source>
      resourceCode="sources"
      titleKey="sources.pageTitle"
      idField="sourceId"
      getRows={getSources}
      saveBatch={(added, modified, deletedIds) =>
        saveSourcesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={sourcesColumnDefs}
      newRowDefaults={newSourceDefaults}
    />
  );
}
